var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebchatNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#945AF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.998 9.554c.67-.282 1.199-.666 1.586-1.153.387-.486.58-1.015.58-1.588 0-.573-.193-1.102-.58-1.589-.388-.486-.916-.87-1.586-1.153a5.568 5.568 0 00-2.185-.423 5.57 5.57 0 00-2.185.423c-.67.283-1.198.667-1.585 1.153-.388.487-.581 1.016-.581 1.589 0 .49.146.952.439 1.385.292.432.694.797 1.205 1.094a3.39 3.39 0 01-.127.272 1.566 1.566 0 01-.154.238l-.14.179a2.447 2.447 0 01-.16.182 4.422 4.422 0 00-.195.214c-.002-.003-.01.008-.025.03l-.021.034-.016.031a.132.132 0 00-.012.037.242.242 0 00-.003.04c0 .015.002.028.006.04a.205.205 0 00.071.13c.04.033.081.05.127.05h.018a5.18 5.18 0 00.532-.1 5.197 5.197 0 001.718-.79c.371.065.734.098 1.088.098.787 0 1.516-.14 2.185-.423z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 9.783c.292-.43.439-.893.439-1.388 0-.506-.155-.98-.464-1.422-.31-.44-.73-.807-1.261-1.1a3.19 3.19 0 01-.272 2.51 4.137 4.137 0 01-1.187 1.31 5.474 5.474 0 01-1.632.798 6.533 6.533 0 01-2.454.253c.828.544 1.801.816 2.918.816.354 0 .717-.033 1.088-.099a5.197 5.197 0 001.718.791c.148.037.326.07.532.1.049.003.095-.011.136-.044a.229.229 0 00.08-.136c-.002-.025 0-.038.006-.04.006-.002.005-.015-.003-.04l-.012-.037-.016-.031a.285.285 0 00-.046-.065.755.755 0 01-.053-.059 4.27 4.27 0 00-.142-.154 2.472 2.472 0 01-.16-.182l-.14-.18a1.562 1.562 0 01-.154-.238 3.394 3.394 0 01-.127-.272c.511-.297.913-.66 1.206-1.091z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/webchat-new.8a69f5257ca138adb9c90755a0761663.svg";
export { SvgWebchatNew as ReactComponent };